/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Contract_SendInputs */

const cs_enum_contract_send = /** @type {(inputs: Enum_Contract_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odeslání smlouvy`)
};

const en_enum_contract_send = /** @type {(inputs: Enum_Contract_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send contract`)
};

/**
* | output |
* | --- |
* | "Send contract" |
*
* @param {Enum_Contract_SendInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_contract_send = /** @type {((inputs?: Enum_Contract_SendInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Contract_SendInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_contract_send(inputs)
	return cs_enum_contract_send(inputs)
});